import { type ChipProps } from "@mui/material/Chip";
import { type WorkflowStatus } from "@utils/types/cms";
import { EnumChip } from "@ui-kit/enum-chip";

const STATUS_COLOR_MAP: Record<WorkflowStatus, ChipProps["color"]> = {
  PUBLISHED: "success",
  READY_FOR_REVIEW: "info",
  REJECTED: "error",
  ARCHIVED: "default",
  UNPUBLISHED: "default",
  DRAFT: "warning",
};

export const formatWorkflowStatus = (status: WorkflowStatus): string =>
  status
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

type WorkflowStatusChipProps = Omit<ChipProps, "color" | "label"> & {
  status: WorkflowStatus;
};

export const WorkflowStatusChip = ({
  status,
  ...rest
}: WorkflowStatusChipProps) => {
  return (
    <EnumChip
      preserveCasing
      capitalise
      {...rest}
      label={formatWorkflowStatus(status)}
      color={STATUS_COLOR_MAP[status]}
    />
  );
};
